import {Controller} from "stimulus";

// Enables only the facility type form's application term fields that the
// chosen term uses (Project #360): no term uses none of them, an Annual -
// Rolling term uses the renewal lead time, and an Annual term also uses the
// fixed expiration month and day. Unused fields stay in the form, disabled,
// so their labels and any server-side errors still render; a disabled field
// is not submitted, so its stored value is left as it was.
export default class extends Controller {
    static targets = ["kind", "renewalField", "annualField"];

    connect() {
        this.refresh();
    }

    refresh() {
        const kind = this.kindTarget.value;
        this.renewalFieldTargets.forEach((field) => { field.disabled = kind === "none"; });
        this.annualFieldTargets.forEach((field) => { field.disabled = kind !== "annual"; });
    }
}
